import { Theme } from "common";

export const studyFiltersStyles = {
  wrapper: {
    margin: Theme.spacing(1),
    position: "relative",
  },
  chip: {
    margin: "2px",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  labelWrapper: {
    whiteSpace: "nowrap",
  },
  customHeaderPadding: {
    padding: "15px",
  },
  customAutocompletePadding: {
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "15px",
  },
  datePicker: {
    margin: "10px",
  },
};
